import Vue from 'vue';
import gql from 'graphql-tag';

const customerData = Vue.$session.get('customer-data') || {};

export default {
    namespaced: true,
    state: {
        customerData,
        watcher: null,
        customerHasDSGVO: false,
    },
    mutations: {
        setCustomerData(state, value) {
            state.customerData = value;
        },
        setWatcher(state, value) {
            state.watcher = value;
        },
        setCustomerHasDSGVO: (state, customerHasDSGVO) => state.customerHasDSGVO = customerHasDSGVO,
    },
    actions: {
        hasDSGVO({ state, commit }) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query customerHasDSGVO($email: String!) {
                        customerHasDSGVO(email: $email) {
                            hasDSGVO
                            }
                        }
                    `,
                    variables: {
                        email: state.customerData.email,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(r => commit('setCustomerHasDSGVO', r.data.customerHasDSGVO.hasDSGVO));
        },
        saveDSGVO({ state, rootState, commit }) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                    mutation(
                        $email: String!,
                        $billingAddress: JSON!
                        $shippingAddress: JSON!
                    ) {
                        customerSaveDSGVO(
                            email: $email,
                            billingAddress: $billingAddress,
                            shippingAddress: $shippingAddress
                        ) {
                            hasDSGVO
                        }
                    }
                `,
                    variables: {
                        email: state.customerData.email,
                        billingAddress: rootState.BillingAddressForm.address,
                        shippingAddress: rootState.ShippingAddressForm.address,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(r => commit('setCustomerHasDSGVO', r.data.customerSaveDSGVO.hasDSGVO));
        },
        registerCustomer({commit}, data) {
            if (!data.guest) {
                delete data.guest;

                return Vue.$graphql
                    .mutate({
                        mutation: gql`
                        mutation($data: NewCustomerInput!, $language: String!) {
                            registration(data: $data, language: $language) {
                                token
                                success
                                errors
                            }
                        }
                    `,
                        variables: {
                            data,
                            language: Vue.$language.getLanguage()
                        },
                    })
                    .then(r => r.data.registration);
            } else {
                const customerData = {
                    email: data.username,
                };
                commit('setCustomerData', customerData);
                Vue.$session.set('customer-data', customerData);

                return Promise.resolve({
                    success: true,
                });
            }
        },
        loadCustomerData({state, commit, dispatch, rootGetters}) {
            if (!state.watcher) {
                commit('setWatcher', Vue.$store.watch(
                    () => rootGetters['Login/isUserLoggedIn'],
                    (value) => {
                        if (!value) {
                            commit('setCustomerData', {});
                        } else {
                            dispatch('loadCustomerData');
                        }
                    }
                ));
            }
            if (rootGetters['Login/isUserLoggedIn']) {
                return Vue.$graphql
                    .query({
                        query: gql`
                            query customer {
                                customer {
                                    email
                                    firstName
                                    nickname
                                    lastName
                                }
                            }
                        `,
                        fetchPolicy: 'no-cache',
                    })
                    .then(r => r.data.customer)
                    .then(data => {
                        commit('setCustomerData', data);
                        return dispatch('hasDSGVO')
                            .then(() => {
                                return data;
                            });

                    })
                    .catch((e) => {
                        commit('setCustomerData', {});
                    });
            } else {
                commit('setCustomerData', Vue.$session.get('customer-data') || {});

                return Promise.resolve(state.customerData);
            }
        },
    },
};
